import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const ArrowReplyOutline = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.79 6.047c-1.3 1.06-3.663 2.945-5.71 4.856a.836.836 0 0 0-.015 1.213c2.05 1.992 4.422 3.778 5.726 4.84a.55.55 0 0 0 .857-.217.6.6 0 0 0 .041-.343l-.398-2.277c5.625-1.402 7.971 1.74 8.875 3.767.132.296.689.239.718-.085.723-8.385-4.578-9.6-9.611-8.811l.416-2.383a.6.6 0 0 0-.04-.343.57.57 0 0 0-.222-.26.54.54 0 0 0-.635.04"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(ArrowReplyOutline) as SvgIcon;
export { ForwardRef as ReactComponent };
